"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TakeHomeExample = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = __importDefault(require("react"));
const Spacer_1 = require("../../../components/spacer/Spacer");
const theme_1 = __importDefault(require("../../../components/styles/theme"));
const StyledTakeHomePanel = styled_1.default.div `
	// 009C60 with 15% opacity (26 suffix)
	background-color: #00B08726;
	padding: 20px;
	border-radius: 5px;
	transition: background-color 0.2s, border 0.2s;
	position: relative;
	margin: 0 0;
	color: ${theme_1.default.palette.greyscale.white};
`;
const StyledTakeHomeRow = styled_1.default.div `
	display: flex;
	justify-content: space-between;
	margin-bottom: ${theme_1.default.layout.spacing.smaller};
	${theme_1.default.typography.d1};
	font-size: 0.875rem;
	font-weight: 400;

	p {
		color: ${theme_1.default.colours.text.darkest};
	}
`;
const StyledPaidToYouRow = (0, styled_1.default)(StyledTakeHomeRow) `
	font-size: 1rem;
	line-height: 1.25rem;
	color: ${theme_1.default.colours.text.darkest};
	margin-top: ${theme_1.default.layout.spacing.standard};
	font-weight: 500;
	margin-bottom: 0;
`;
const StyledHeader = styled_1.default.h2(theme_1.default.typography.a3);
const TakeHomeExample = (props) => {
    var _a, _b;
    const currency = (_a = props.currency) !== null && _a !== void 0 ? _a : '£';
    const guestPaid = 100;
    const tnFeeValue = guestPaid * props.tnFee;
    const channelFeeValue = guestPaid * props.channelFee;
    const dealValue = ((_b = props.dealAdjustment) !== null && _b !== void 0 ? _b : 0) * guestPaid;
    const dealSign = Math.sign(dealValue) === -1 ? '+' : '-';
    const takeHome = guestPaid - tnFeeValue - channelFeeValue - dealValue;
    return react_1.default.createElement(StyledTakeHomePanel, { "data-testid": "take-home-example" },
        react_1.default.createElement(StyledHeader, null, "1 night stay at \u00A3100 per night"),
        react_1.default.createElement(Spacer_1.Spacer, null),
        react_1.default.createElement(StyledTakeHomeRow, null,
            react_1.default.createElement("p", null, "Guest pays"),
            react_1.default.createElement("p", null,
                currency,
                guestPaid)),
        react_1.default.createElement(StyledTakeHomeRow, null,
            react_1.default.createElement("p", null,
                "Travelnest Fee (",
                props.tnFee * 100,
                "%)"),
            react_1.default.createElement("p", null,
                "- ",
                currency,
                tnFeeValue)),
        dealValue !== 0 && react_1.default.createElement(StyledTakeHomeRow, null,
            react_1.default.createElement("p", null,
                "Welcome Deal (save ",
                Math.abs(props.dealAdjustment * 100),
                "%)"),
            react_1.default.createElement("p", null,
                dealSign,
                " ",
                currency,
                Math.abs(dealValue))),
        react_1.default.createElement(StyledTakeHomeRow, null,
            react_1.default.createElement("p", null,
                "Channel Fee (",
                props.channelFee * 100,
                "%)"),
            react_1.default.createElement("p", null,
                "- ",
                currency,
                channelFeeValue)),
        react_1.default.createElement(StyledPaidToYouRow, null,
            react_1.default.createElement("p", null, "\uD83D\uDCB8 Paid to you"),
            react_1.default.createElement("p", null,
                currency,
                takeHome)));
};
exports.TakeHomeExample = TakeHomeExample;
//# sourceMappingURL=TakeHomeExample.js.map